import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right\"><defs><style>#right *{text-shadow:transparent 0 0 0,rgba(0,0,0,.68) 0 0 0!important}</style></defs><path d=\"M739.461 497.142L355.697 113.377a35.83 35.83 0 10-50.678 50.678l358.42 358.42-358.42 358.421a35.83 35.83 0 1050.678 50.678L739.46 547.809c7.004-7.004 10.496-16.158 10.496-25.344s-3.502-18.33-10.496-25.323z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol